import { takeLatest, call, put } from 'redux-saga/effects';
import { fetchCountriesSuccess, fetchCountriesFail } from 'modules/common/commonSlice';
import { supportedCountriesIds } from 'constants/general';
import { getCountries } from './api';

const countriesMapper = countries =>
  countries
    .filter(country => supportedCountriesIds.includes(country.CountryId))
    .reduce((countriesDic, country) => {
      // eslint-disable-next-line no-param-reassign
      countriesDic[country.CountryId] = {
        id: country.CountryId,
        name: country.LanguageItemModels[0]?.Name,
        IconUrl: country.IconUrl,
        currency: {
          name: country?.CountryCourrencies?.CurrencyModels?.filter(
            currency => currency.IsDefault,
          )[0]?.LanguageItemModels?.[0]?.Name,
        },
      };
      return countriesDic;
    }, {});
function* fetchCountriesSaga(payload) {
  try {
    const response = yield call(getCountries, payload);
    yield put(fetchCountriesSuccess(countriesMapper(response.data.Data)));
  } catch (error) {
    yield put(fetchCountriesFail(error));
  }
}

function* commonSaga() {
  yield takeLatest('common/fetchCountries', fetchCountriesSaga);
}

export default commonSaga;
